require.register("app/restaurant/show/StatTab", function(exports, require, module){
  $0
  
});

